import { JSLog } from "@zg-reportsus/zg-reportsus-common-js";
import { globals } from "./config";
import { ErrorCodes, getErrorMessages, InfoMessages } from "./error_translations";
import { MSAL, handleAuthResponse, loginRequest } from "./auth";

declare const $;

if (window.ewtGlobals) {    
    globals.brandName = window.ewtGlobals.brandName;
    globals.traceId = window.ewtGlobals.traceId;
    globals.decryptedParams = window.ewtGlobals.decryptedParams;
    globals.viewMessage = window.ewtGlobals.viewMessage;
    globals.workflowUrl = window.ewtGlobals.workflowUrl;
}

var traceId = globals.traceId;
var workflowUrl = globals.workflowUrl;
var decryptedParams = globals.decryptedParams;
var displayPromptUrl = workflowUrl.replace("ProcessWorkflow", "DisplayPrompt");
var defaultError = "An error occurred that prevented your email from being reported. Please try again later";
var token = "";

JSLog.init({url: '/EWT/v1/js', headers: {
    'X-PFPT-TraceId': globals.traceId
}});

var localeMap = {
    "ar": "ar-EG",
    "vi": "vi-VN",
    "no": "no-NO",
    "hi": "hi-IN",
    "km": "km-KH",
    "ja": "ja-JP",
    "my": "my-MM",
    "ms": "ms-MY",
    "cs": "cs-CZ",
    "da": "da-DK",
    "el": "el-GR",
    "he": "he-IL",
    "sr": "sr-SP"
};

var ewt_actions = (function () {

    var findMessageOfType = function (messageType, messageDict) {
        let lang;
        if (messageType in messageDict) {
            lang = getLanguage().toUpperCase();
            if (lang && lang.length === 2) {
                for (const [key, value] of Object.entries(messageDict[messageType])) {
                    if (key.startsWith(lang)) {
                        return value;
                    }
                }
            } else {
                if (lang in messageDict[messageType]) {
                    return messageDict[messageType][lang];
                }                        
            }
            console.log("Language " + lang + " not supported");
        }
        const errorMessage = `Message type ${messageType} not found` + (lang ? `; language = ${lang}` : '.');
        console.log(errorMessage);
        JSLog.warn(errorMessage);

        return "";
    };

    var localizeMessage = function (code, messageDict, messageCodes) {
        if (code in messageCodes) {
            var messageType = messageCodes[code];
            return findMessageOfType(messageType, messageDict);
        }
        return "";
    };

    var localizeInfo = function (messageType, defaultMessage) {
        var message = findMessageOfType(messageType, InfoMessages);
        return message === "" ? defaultMessage : message;
    };

    var localizeError = function (code, defaultMessage) {
        var message = localizeMessage(code, getErrorMessages(globals.brandName), ErrorCodes);
        return message === "" ? defaultMessage : message;
    };

    var parseErrorResponse = function (response) {
        try {
            if (response && typeof (response) === 'object') {
                if (response.errorCode !== null) {
                    var errorCode = response.errorCode;
                    return localizeError(errorCode, defaultError);
                } else if (response.errorMessage) {
                    return response.errorMessage;
                }
            }
        } catch (e) {
            JSLog.error(e);
            console.log(e);
            return defaultError;
        }
        return defaultError;
    };

    var getLanguage = function () {
        if (navigator.languages && navigator.language.length) {
            return navigator.languages[0];
        } else {
            return navigator.language || (<any>navigator).browserLanguage || (<any>navigator).userLanguage;
        }
    };

    var findLocale = function () {
        var locale = getLanguage();
        if (!locale) {
            return "en-US";
        }
        if (locale.length == 2) {
            if (locale in localeMap) {
                return localeMap[locale];
            }
            locale = locale + "-" + locale.toUpperCase();
        }
        return locale;
    };
    
    var checkShouldPrompt = function () {
        var confirmTextDiv = $('.ewt-confirm-text');
        var retrieveText = localizeInfo("EMAIL_RETRIEVE", "Retrieving the reported email");
        confirmTextDiv.text(retrieveText);
        performRequest(displayPromptUrl, null, evaluateAuthMethodCallback);
    };

    var performRequest = function (url, confirmationType, callback, requestObj = null) {
        if (!requestObj) {
            requestObj = baseRequestData(confirmationType);
            if (token !== "") {
                requestObj['token'] = token;
            }
        }

        var xhr = $.ajax({
            type: 'POST',
            url: url,
            data: requestObj,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'X-PFPT-TraceId': traceId
            },
            dataType: 'json',
            success: callback,
            error: failureCallback
        });
    };
    var baseRequestData = function (confirmationType) {
        var params = new URLSearchParams(decryptedParams);
        var returnValue = {
            'promptResponse': confirmationType,
            'customerId': params.get('customerId'),
            'companyId': params.get('companyId'),
            'userHostAddress': '',
            'userAgent': navigator.userAgent,
            'messageId': params.get('messageId'),
            'userEmailAddress': params.get('userEmailAddress'),
            'token': token ? token : null,
            'locale': findLocale()
        };
        if (typeof window.m365AuthData.Reporter !='undefined' && window.m365AuthData.Reporter) {
            returnValue['graphUser'] = window.m365AuthData.Reporter;
        }
        if (window.m365AuthData.M365AuthFailed) {
            returnValue['m365AuthFailed'] = true;
        }
        return returnValue;
    };
    var workflowRequestData = function (confirmationType, response) {
        var requestObj = baseRequestData(confirmationType);
        var uncap = [ 'apiToken', 'apiSecret', 'analyzerGuid'];
        
        var fields = {
            'includeAttachments': 'includeAttachments', 'AnalyzerGuid': 'analyzerGuid', 'ApiToken': 'apiToken',
            'ApiSecret': 'apiSecret', 'isUsingTrialAdmin': 'isUsingTrialAdmin', 'whitelistSendToAnalyzer': 'whitelistSendToAnalyzer'
        };
        for (var f in fields) {
            requestObj[fields[f]] = response[f];
        }
        if ('apiToken' in response) {
            for (var v in uncap) {
                requestObj[uncap[v]] = response[uncap[v]];
            }
        }
        return requestObj;
    };

    var displayPromptSuccessCallback = function (response) {
        var confirmTextDiv = $('.ewt-confirm-text');
        if (!response || response.message === "Access Denied") {
            failureCallback(null);
            return;
        }

        token = response.token;
        // get responseType of either "whitelist" or "confirmation" -
        // defaults to confirmation (EWT does not support one-click layout)
        var confirmationType = response.responseType || "confirmation";
        var message = response.message || "";

        var breakRegex = /(\r?\n)/gm;
        if (breakRegex.test(message)) {
            var breaks = message.split(breakRegex);
            confirmTextDiv.text("");
            for (var i = 0; i < breaks.length; i++) {
                var line = breaks[i];
                if (line.length > 0) {
                    confirmTextDiv.append($.parseHTML("<div>" + line + "</div>"));
                }
            }
        } else {
            var parsedHtml = $.parseHTML(message);
            confirmTextDiv.html(parsedHtml);
        }

        if (response.reportPhish365) {
            $('.confirm').find('span').text(response.reportPhish365);
        }

        if (response.cancel) {
            $('.cancel').find('span').text(response.cancel);
        }

        $('.confirm').show();
        $('.cancel').show();
        $('.cancel').on('click', submitCancel);
        $('.confirm').on('click', function () {
            submitConfirm(confirmationType, response)
        });
    };

    var evaluateAuthMethodCallback = function (response) {
        if (response.isM365AuthEnabled && !window.m365AuthData.M365AuthFailed) {
            useM365Auth();
        } else {
            displayPromptSuccessCallback(response);
        }
    };

    // this function is only called if M365 auth is enabled and we didn't redirect (yet)
    var useM365Auth = async function () {
        try {
            await MSAL.initialize();

            let account = MSAL.getActiveAccount();
            if (!account) {
                const accounts = MSAL.getAllAccounts();
                if (accounts.length > 0) {
                    // If we have accounts, set the first one as active
                    MSAL.setActiveAccount(accounts[0]);
                    account = MSAL.getActiveAccount();
                } else {
                    // If no active account, we need to login
                    MSAL.loginRedirect(loginRequest);
                }
            }

            let username = account?.username;
            if (typeof username !== "undefined" && username) {
                // If we have a username, we can set it as the reporter
                JSLog.notify("Using M365 Auth with username: " + username);
                window.m365AuthData.Reporter = username;
                window.m365AuthData.M365AuthFailed = false;
            } else {
                JSLog.error("No active account found in MSAL. Cannot proceed with M365 Auth.");
                window.m365AuthData.M365AuthFailed = true;
            }
        } catch(e) {
            JSLog.error("Error during Graph initialization: " + e.message);
            window.m365AuthData.M365AuthFailed = true;
            return checkShouldPrompt(); // fallback to the old method
        }

        checkShouldPrompt(); // goes back to EWT processor
    };

    var confirmSuccessCallback = function (response) {
        var message = response.message;
        if (response.Forward) {
            message = response.Forward.message;
        }
        else if (response.Whitelist) {
            message = response.Whitelist.message;
        }
        message = message.replace(/(\r\n|\n|\r)/gm, "<br>");
        var confirmDiv = $('.confirm-prompt');
        confirmDiv.empty();

        var responseDiv = $("<div>" + message +  "</div>");
        responseDiv.addClass("ewt-response");

        responseDiv.appendTo(confirmDiv);
    };

    var failureCallback = function (response) {
        var errorMessage = parseErrorResponse(response.responseJSON);

        //default to an error message just in case. Possible if the language isn't supported.  
        //Don't want to see 'undefined' instead
        if (!errorMessage) {
            errorMessage = getErrorMessages(globals.brandName)["DEFAULT"]["EN-US"];
        }

        var errorDiv = $("<div>" + errorMessage + "<br>TraceId: " + traceId + "</div>");
        errorDiv.addClass("ewt-response");

        var confirmDiv = $('.confirm-prompt');
        confirmDiv.empty();
        errorDiv.appendTo(confirmDiv);
    };

    var submitCancel = function () {
        event.preventDefault();
        var confirmDiv = $('.confirm-prompt');
        confirmDiv.empty();
        var localizedCancel = localizeInfo("CANCEL1", "You have chosen to not report this email. Continue to be cautious with emails you find suspicious.");
        var localizedClose = localizeInfo("CANCEL2", "Please close this browser window.");
        var closeMsg1 = $("<div>" + localizedCancel + "</div>");
        var divider = $("<div>&nbsp;</div>")
        var closeMsg2 = $("<div>" + localizedClose + "</div>");
        closeMsg1.addClass("ewt-response");
        divider.addClass("ewt-response");
        closeMsg2.addClass("ewt-response");
        closeMsg1.appendTo(confirmDiv);
        divider.appendTo(confirmDiv);
        closeMsg2.appendTo(confirmDiv);
    };

    var submitConfirm = function (confirmationType, response) {
        event.preventDefault();
        var confirmDiv = $('.confirm-prompt');
        confirmDiv.empty();
        var localizedWait = localizeInfo("WAITING", "Waiting for response..");
        var waiting = $("<div>" + localizedWait +"</div>");
        waiting.addClass("ewt-response");
        waiting.appendTo(confirmDiv);

        performRequest(workflowUrl, confirmationType, confirmSuccessCallback, workflowRequestData(confirmationType, response));
    };
    
    var handleAuthResponseAndRedirect = async function () {
        let redirectUrl = `/EWT/v1/`;
        const ewtParams = getEncryptedParamsFromHashState();
        if (ewtParams) {
            redirectUrl += `${ewtParams}`;
        }

        try {
            await MSAL.initialize();
            const response = await MSAL.handleRedirectPromise();
            await handleAuthResponse(response);

            if (window.m365AuthData.M365AuthFailed) {
                JSLog.error("M365 Auth failed, redirecting to EWT processor.");
                redirectUrl += `?redirect=internal&M365AuthFailed=true`;
            } else {
                JSLog.notify("M365 Auth successful, proceeding with EWT processor.");
                const graphUser = window.m365AuthData.Reporter;
                redirectUrl += `?graphUser=${graphUser}&redirect=internal&M365AuthFailed=false`;
            }
        } catch (error) {
            JSLog.error("Error during MSAL redirect handling:", error);
            window.m365AuthData.M365AuthFailed = true;
            redirectUrl += `?redirect=internal&M365AuthFailed=true`;
        }

        window.location.href = redirectUrl; // Redirect to the EWT processor with the necessary parameters
    };

    var getEncryptedParamsFromHashState = function () {
        const fullHash = window.location.hash;

        if (fullHash) {
            const hashWithoutHashmark = fullHash.substring(1); 
            const params = new URLSearchParams(hashWithoutHashmark);
            const encodedState = params.get('state');
            if (encodedState) {
                const state = decodeURIComponent(encodedState);
                const stateParams = state.split('|'); // constant set by Microsoft Authentication Library
                if (stateParams.length > 1) {
                    return stateParams[1]; // the second part is the EWT encrypted params
                }
            }
            JSLog.error("No 'state' parameter found in the URL hash.");
        } else {
            JSLog.error("No hash found in the URL.");
        }
    };

    var begin = async function () {
        if (window.m365AuthData.M365AuthRedirect) {
           handleAuthResponseAndRedirect();
        } else {
            checkShouldPrompt();
        }
    };
    return {
        begin: begin
    };
})();

var checkCanBegin = function () {
    if (decryptedParams || window.m365AuthData.M365AuthRedirect) {
        ewt_actions.begin();
        clearInterval(handle);
    }
};

var handle = setInterval(checkCanBegin, 500);